import React from 'react';
import { CheckIcon } from 'lucide-react';
import { categoryTags, systemStats } from '../data/landing';
export function SystemSection() {
  return <section className="border-y-4 border-gold bg-ink-mid px-5 py-20" data-id="element-198" data-mp="3gircz30wxxv4">
      <div className="mx-auto max-w-6xl text-center" data-id="element-199" data-mp="3bhllf8izogn6">
        <p className="inline-block bg-gold px-4 py-2 text-xs font-bold uppercase tracking-widest text-ink" data-id="element-200" data-mp="36jsg0hpifqny">
          The most complete system for tennis coaches worldwide
        </p>
        <h2 className="mt-7 font-display text-5xl font-bold uppercase leading-none text-white sm:text-7xl" data-id="element-201" data-mp="31mjx2ewjfiln">
          Tennis <span className="text-gold" data-id="element-202" data-mp="2ssf1xjadfl0b">Ready™</span>
        </h2>
        <p className="mx-auto mt-6 max-w-2xl text-base font-medium leading-relaxed text-slate-300" data-id="element-203" data-mp="2ssnd96quii9e">
          Over 300 pages of lesson plans, professional technical drills, tactical
          games, physical conditioning and academy-management tools —{' '}
          <strong className="text-white" data-id="element-204" data-mp="2duuy4fp7nvvq">all done for you.</strong>
        </p>
        <div className="mt-11 grid grid-cols-2 gap-3 lg:grid-cols-4" data-id="element-205" data-mp="13zhq94swj7zb">
          {systemStats.map(({
          icon: Icon,
          value,
          label
        }) => <div key={label} className="border border-gold/25 bg-ink p-6" data-id="element-206" data-mp="18qzovm7gcwh4">
              <Icon className="mx-auto h-7 w-7 text-gold" data-id="element-207" data-mp="u1k1mg74r966" />
              <p className="mt-4 font-display text-4xl font-bold text-white" data-id="element-208" data-mp="tyxlvta35ncv">
                {value}
              </p>
              <p className="text-xs font-bold uppercase tracking-widest text-slate-300" data-id="element-209" data-mp="1mppmd2y6oy60">
                {label}
              </p>
            </div>)}
        </div>
        <div className="mt-4 border border-gold/25 bg-ink p-7" data-id="element-210" data-mp="1rmpv5lmf4f0t">
          <p className="text-xs font-bold uppercase tracking-[.2em] text-white" data-id="element-211" data-mp="1cqi1zvt1839e">
            Full coverage — beginner to high performance
          </p>
          <div className="mt-5 flex flex-wrap justify-center gap-2" data-id="element-212" data-mp="1hsfnyxsthc61">
            {categoryTags.map(tag => <span key={tag} className="flex items-center gap-1.5 border border-gold/25 bg-ink-mid px-3 py-2 text-xs font-bold text-white" data-id="element-213" data-mp="6b7ngnlakg75">
                <CheckIcon className="h-3.5 w-3.5 text-gold" data-id="element-214" data-mp="23z1ocv9wg8sv" />
                {tag}
              </span>)}
          </div>
        </div>
      </div>
    </section>;
}